import { render } from "./UpdateNotesDialog.vue?vue&type=template&id=26041e80&scoped=true"
import script from "./UpdateNotesDialog.vue?vue&type=script&lang=js"
export * from "./UpdateNotesDialog.vue?vue&type=script&lang=js"

import "./UpdateNotesDialog.vue?vue&type=style&index=0&id=26041e80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26041e80"

export default script